module.exports = __webpack_public_path__ + "static/media/powershades_office.35680be8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/powershades_office.jpeg
// module id = 229
// module chunks = 0